import { createBrowserRouter } from "react-router"
import { type Router } from "./types"
import { getRoutes } from "./routes"

let router: Router | null = null

export const createRouter = () => {
  if (!router) {
    router = createBrowserRouter(getRoutes())
  }

  return router
}

export const getRouter = () => {
  return createRouter()
}
